import { save, load, logX, parseJSON } from '../common/libs/utils';
import store from '../store';

export const processText = text => {
	if (Array.isArray(text) && text.length > 0) {
		text = text[0];
	}
	if (typeof text !== 'string') return text;
	text = text.replace(/\{\{\s*user\.(.+?)\s*\}\}/g, (_, attr) => store.state.user?.[attr] ?? `{{user.attr}}`);
	text = text.replace(/\{\{\s*(.+?)\s*\}\}/g, (_, attr) => store.state.user[attr] ?? `{{${attr}}}`);
	return text;
}

export const saveVariable = (key, value, data, source) => {

	let variable;
	if (variable = /\{\{\s*(.*)\s*\}\}/[Symbol.match](value)?.[1]) {
		const vars = getAllVariables();
		variable = variable.replace(/\b([^\d()*/+-][^()*/+-]*?)\b/gi, '(isNaN(vars["$1"]) ? vars["$1"] : +vars["$1"])');
		try {
			let expression = `(() => {
				return ${variable};
			})()`;
			value = eval(expression);
		} catch(ex) {
			console.error('Passing expressing: ' + variable);
		}
	}

	store.state.user[key] = value;
	logX('UKEY', 'purple', key, value, data);
	// let token = window.localStorage.getItem('anybot_user_token');
	// let access_key = store.state.bot.key;
	// try {
	// 	const payload = {
	// 		token, access_key,
	// 		rid: data.id,
	// 		[key]: value,
	// 		ctypes: JSON.stringify({
	// 			[key]: ({ action: 'btns', miniapp: 'btns', input: 'ipts' })[source] || 'ipts'
	// 		}),
	// 		zone: new Date().getTimezoneOffset() / -60
	// 	};
	// 	http.post('/api/sdk/me', payload, undefined, { useRoot: true });
	// 	// http.post('/me', payload);
	// } catch (ex) {

	// }
	save('user-variable', JSON.stringify(store.state.user));
}

export const getAllVariables = () => {
	return { ...store.state.user };
}

export const initUserVariables = () => {
	const uv = load('user-variable');
	if (uv) {
		Object.assign(store.state.user, parseJSON(uv));
	}
}
